import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  IconButton,
  Box,
  Typography,
  Slide,
  alpha,
  Divider,
} from '@mui/material';
import { Close, Save } from '@mui/icons-material';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const FormDialog = ({
  open,
  title,
  subtitle,
  icon,
  children,
  onClose,
  onSubmit,
  submitLabel = 'Guardar',
  submitIcon = <Save />,
  cancelLabel = 'Cancelar',
  maxWidth = 'sm',
  loading = false,
  disableSubmit = false,
  showDividers = true,
  fullScreen = false,
  hideActions = false,
  extraActions,
  sx = {},
}) => {
  const handleSubmit = (e) => {
    e?.preventDefault();
    onSubmit?.();
  };

  return (
    <Dialog
      open={open}
      onClose={loading ? undefined : onClose}
      maxWidth={maxWidth}
      fullWidth
      fullScreen={fullScreen}
      TransitionComponent={Transition}
      sx={{
        '& .MuiDialog-paper': {
          borderRadius: fullScreen ? 0 : 3,
          ...sx,
        },
      }}
    >
      <DialogTitle
        sx={{
          display: 'flex',
          alignItems: 'flex-start',
          justifyContent: 'space-between',
          gap: 2,
          pb: subtitle ? 1 : 2,
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          {icon && (
            <Box
              sx={{
                p: 1.5,
                borderRadius: 2,
                backgroundColor: (theme) => alpha(theme.palette.primary.main, 0.08),
                color: 'primary.main',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              {icon}
            </Box>
          )}
          <Box>
            <Typography variant="h6" sx={{ fontWeight: 600 }}>
              {title}
            </Typography>
            {subtitle && (
              <Typography variant="body2" color="text.secondary">
                {subtitle}
              </Typography>
            )}
          </Box>
        </Box>
        <IconButton
          onClick={onClose}
          disabled={loading}
          sx={{
            color: 'text.secondary',
            '&:hover': {
              backgroundColor: (theme) => alpha(theme.palette.error.main, 0.08),
              color: 'error.main',
            },
          }}
        >
          <Close />
        </IconButton>
      </DialogTitle>

      {showDividers && <Divider />}

      <form onSubmit={handleSubmit}>
        <DialogContent
          sx={{
            py: 3,
            '&::-webkit-scrollbar': {
              width: '8px',
            },
            '&::-webkit-scrollbar-track': {
              background: '#f1f5f9',
              borderRadius: '4px',
            },
            '&::-webkit-scrollbar-thumb': {
              background: '#cbd5e1',
              borderRadius: '4px',
              '&:hover': {
                background: '#94a3b8',
              },
            },
          }}
        >
          {children}
        </DialogContent>

        {showDividers && !hideActions && <Divider />}

        {!hideActions && (
          <DialogActions
            sx={{
              px: 3,
              py: 2.5,
              gap: 1,
            }}
          >
            {extraActions}
            <Box sx={{ flex: 1 }} />
            <Button
              onClick={onClose}
              disabled={loading}
              variant="text"
              sx={{
                color: 'text.secondary',
                px: 3,
                '&:hover': {
                  backgroundColor: (theme) => alpha(theme.palette.grey[500], 0.08),
                },
              }}
            >
              {cancelLabel}
            </Button>
            <Button
              type="submit"
              variant="contained"
              disabled={loading || disableSubmit}
              startIcon={loading ? null : submitIcon}
              sx={{
                px: 3,
                minWidth: 120,
              }}
            >
              {loading ? 'Guardando...' : submitLabel}
            </Button>
          </DialogActions>
        )}
      </form>
    </Dialog>
  );
};

export default FormDialog;
